module.exports = __webpack_public_path__ + "img/addUnitWifi.d4310893.png";